// Extraído de ModificarFechaLoteCapexModal (handleGuardar) — Fase 1 de "Futuros: reagendar"
// (2026-09-23). Mismo comportamiento exacto: se movió el cuerpo de la función a un util standalone
// para que el modal Y el despachador nuevo `reagendarEntryFuturo` llamen a LA MISMA función (10.1).
//
// Línea FOB del lote (sin costo_id) → actualizarLote(loteId, { fecha_planificada }).
// Línea componente (con costo_id)   → actualizarCostoLote(costoId, { fecha_pago }).
// Antes de escribir se carga el cuadro REAL del lote (fecha_planificada del lote + componentes vía
// getCostosDeLote — releído de DB, no de la proyección que puede estar stale), se aplica la nueva
// fecha a la línea editada y se corre validarOrdenFechasLote (FOB ≤ Transporte < Aduana); si viola,
// bloquea con el mismo mensaje y NO escribe ninguna de las dos tablas.
//
// Devuelve `{ error: string }` si la validación de orden bloquea el guardado, o `{ success: true }`.
// La UI (toast, loading) queda fuera de este util a propósito — el caller decide cómo mostrarla.
import { actualizarCostoLote, getCostosDeLote, validarOrdenFechasLote } from "./loteCostos";
import { actualizarLote, getLoteById } from "./lotesCompra";

const normalizarFecha = (fechaStr) => {
  if (!fechaStr) return "";
  return String(fechaStr).includes("T") ? String(fechaStr).substring(0, 10) : String(fechaStr);
};

/**
 * @param {Object} params
 * @param {Object} params.entry - la fila del lote/componente tal como la arma FlujoCajaV2
 *   (lote_id obligatorio; costo_id presente solo si es un componente, ausente si es el FOB).
 * @param {string} params.nuevaFecha - "YYYY-MM-DD"
 */
export const guardarFechaLoteCapex = async ({ entry, nuevaFecha }) => {
  const esComponente = !!entry.costo_id;
  const fecha = normalizarFecha(nuevaFecha);

  const costos = await getCostosDeLote(entry.lote_id);
  let fobFecha;
  let componentesParaValidar;
  if (esComponente) {
    const lote = await getLoteById(entry.lote_id);
    fobFecha = normalizarFecha(lote?.fecha_planificada);
    componentesParaValidar = costos.map((c) => (c.id === entry.costo_id ? { ...c, fecha_pago: fecha } : c));
  } else {
    fobFecha = fecha; // la línea editada ES el FOB
    componentesParaValidar = costos;
  }

  const violaciones = validarOrdenFechasLote(fobFecha, componentesParaValidar);
  if (violaciones.length > 0) {
    return {
      error: `${violaciones[0].mensaje} Para mover varias fechas juntas, editalas desde "Componentes" del lote.`,
    };
  }

  await (esComponente
    ? actualizarCostoLote(entry.costo_id, { fecha_pago: fecha })
    : actualizarLote(entry.lote_id, { fecha_planificada: fecha }));
  return { success: true };
};
